/**
 * GradeBenefitsContainer
 * --
 */
import React from 'react';
import GradeBenefitsPresenter from './GradeBenefitsPresenter';

const GradeBenefitsContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize, location } = props;

  /* ===== Store ===== */

  /* ===== Data ===== */

  /* ===== MUTATE ===== */
  /* ===== STATE ===== */
  const [isCommon, setIsCommon] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  React.useEffect(() => {
    const pathname = location.pathname;

    if (pathname.includes('common')) setIsCommon(true);
    else setIsCommon(false);
  }, [location]);

  /* ===== RENDER ===== */
  return (
    <>
      <GradeBenefitsPresenter screenSize={screenSize} isCommon={isCommon} />
    </>
  );
};

export default GradeBenefitsContainer;
